import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-vehicle-service-details-tab-invoices',
  templateUrl: './vehicle-service-details-tab-invoices.component.html',
  styleUrls: ['./vehicle-service-details-tab-invoices.component.scss'],
  providers: [],
})
export class VehicleDetailsTabInvoicesComponent extends ABaseComponent {
  _vehicleService: VehicleService;

  @Input()
  set vehicleService(v: VehicleService) {
    this._vehicleService = v;
    this.changeHandle();
  }
  get vehicleService() {
    return this._vehicleService;
  }

  dso: DataSourceOptions;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
  ) {
    super(logger);
  }

  changeHandle() {}

  async onInvoiceInserting(event: any): Promise<void> {
    try {
      event.data.id = event.data.__KEY__;
      event.data.createdAt = new Date();
      event.data.updatedAt = new Date();

      let { invoices } = this.vehicleService;
      invoices = [{ ...event.data, __KEY__: undefined }, ...this.vehicleService.invoices];
      this.vehicleService.invoices = invoices; // Update the local state with predicted data

      // Call the API to add the new invoice
      const updatedVehicleService = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { invoices })
        .toPromise();

      // Update the local state with the response
      this.vehicleService.invoices = updatedVehicleService.invoices;
    } catch (error) {
      notify('Error inserting invoice', 'error', 3000);
      console.error('Error inserting invoice:', error);
      event.cancel = true;
    }
  }

  async onInvoiceUpdating(event: any): Promise<void> {
    try {
      const { invoices } = this.vehicleService;
      const index = invoices.findIndex((inv: any) => inv.id === event.key.id);
      if (index !== -1) {
        invoices[index] = { ...invoices[index], ...event.newData, updatedAt: new Date() };
        const { invoices: updatedInvoices } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { invoices })
          .toPromise();
        this.vehicleService.invoices = updatedInvoices;
      }
    } catch (error) {
      notify('Error updating invoice', 'error', 3000);
      console.error('Error updating invoice:', error);
      event.cancel = true;
    }
  }

  async onInvoiceRemoving(event: any): Promise<void> {
    const { invoices } = this.vehicleService;
    const index = invoices.findIndex((inv: any) => inv.id === event.key.id);
    if (index !== -1) {
      invoices.splice(index, 1);
      const { invoices: updatedInvoices } = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { invoices })
        .toPromise();
      this.vehicleService.invoices = updatedInvoices;
    }
  }
}
